import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveReviewRequest } from './save-review-request';
import type { ISaveReviewResponse } from './save-review-response';
import { saveReviewResponseSchema } from './save-review-response';

export async function saveReviewApi(
  body: ISaveReviewRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveReviewResponse>> {
  return postRequest<ISaveReviewResponse>({
    path: '/reviews',
    body,
    schema: saveReviewResponseSchema,
    options,
  });
}
